import { useEffect } from "react";
import { useDispatch } from "react-redux";

import { logout } from "./login.actions";

export const Logout = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(logout());
  }, [dispatch]);

  return null;
};
